module.exports = __webpack_public_path__ + "img/shoplink-sample.e54ae04c.gif";